import { Injectable } from '@angular/core';
import { CRUDService } from 'src/app/core';
import { Subject, Observable } from 'rxjs';
import { IRequestEvent, EActionEvent } from 'src/app/users/src/users.model';
import { EClass } from 'src/app/model';

@Injectable({
	providedIn: 'root',
})
export class ExerciceService extends CRUDService {
	class = EClass.EXERCICE
	exerciceSubjectEvent: Subject<IRequestEvent> = new Subject();
	exerciceEvent: Observable<IRequestEvent> = this.exerciceSubjectEvent.asObservable()


	private _exerciceNext(obj: IRequestEvent) {
		this.exerciceSubjectEvent.next(obj);
	}
	getExerciceList(subscribe: boolean) {
		let res = this.find('data', { c: this.class })
		if (subscribe) {
			res.subscribe(
				data => this._exerciceNext({
					class: this.class,
					action: EActionEvent.FIND,
					data: data,
				}),
				e => console.error(e))
		} else {
			return res;
		}
	}
	getExercice(id: string) {
		this.get(id, 'data', { c: this.class }).subscribe(
			res => this._exerciceNext({
				class: this.class,
				action: EActionEvent.GET,
				data: res
			})
		)
	}
}
